<template>
  <div style="display: contents">
    <tr :class="hasChildren ? 'grey lighten-4 font-weight-bold' : ''">
      <td>
        <v-btn v-if="hasChildren" icon x-small @click="expanded = !expanded" class="mr-1">
          <v-icon>{{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
        </v-btn>
        <span :style="{ marginLeft: hasChildren ? '0px' : '28px' }" class="text-caption">
          {{ item.codigo }}
        </span>
      </td>
      <td :style="{ paddingLeft: level * 20 + 16 + 'px' }">
        {{ item.nombre }}
      </td>
      <td class="text-right">{{ format(item.presupuesto_inicial) }}</td>
      <td v-for="m in mesesKeys" :key="m" class="text-right">
        {{ format(item[m]) }}
      </td>
      <td class="text-right blue--text">{{ format(item.total) }}</td>
      <td class="text-right font-weight-black">{{ format(item.saldo_presupuestario) }}</td>
    </tr>

    <tr>
      <td colspan="15" class="pa-0">
        <v-divider v-if="hasChildren && expanded" class="my-0"></v-divider>
      </td>
    </tr>

    <template v-if="hasChildren && expanded">
      <FilaPartidaAgrupada
        v-for="hijo in item.hijos"
        :key="hijo.id"
        :item="hijo"
        :level="level + 1"
        :meses-keys="mesesKeys"
        :force-expand="forceExpand" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'FilaPartidaAgrupada',
  props: {
    item: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
    mesesKeys: {
      type: Array,
      default: () => [],
    },
    forceExpand: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    forceExpand(val) {
      this.expanded = val;
    },
  },
  data: () => ({
    expanded: true,
  }),
  computed: {
    hasChildren() {
      return this.item.hijos && this.item.hijos.length > 0;
    },
  },
  methods: {
    format(val) {
      return new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2 }).format(val || 0);
    },
  },
};
</script>

<style scoped>
/* Importante para que el div no rompa el layout de la tabla */
div {
  display: contents;
}
</style>